<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmtitle" id="ded"><span class="bold">Dedication</span></h1>
<p class="center">This is dedicated to my first art teachers, Mr Mbaegu and Mr Idika Kalu. They saw this stuff in me and encouraged me at an early age to work hard and reach for the stars!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?0f9c29ec